import { Component, HostListener, Input, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';

@Component({
  selector: 'non-merchant-search',
  standalone: true,
  imports: [MktCommonModule],
  templateUrl: './non-merchant-search.component.html',
  styleUrl: './non-merchant-search.component.scss'
})
export class NonMerchantSearchComponent implements OnInit {

  @Input({required: true}) nonMerchantSearchData;
  csp = inject(CitiShopPropsService);
  platformId = inject(PLATFORM_ID);
  device: string = 'desktop';

  ngOnInit(): void{
    this.onWindowResize();
  }

@HostListener('window:resize', ['$event'])
private onWindowResize() {
     if (isPlatformServer(this.platformId)) return;
     const windowWidth = window ? window.innerWidth : 0;
     if (windowWidth >= 1200) {
         this.device = 'desktop';
     }
     else if (windowWidth >= 768) {
         this.device = 'tablet';
     }
     else {
         this.device = 'mobile';
     }
 }

}
